import React, { useContext } from "react";
import { Avatar, Box, Divider, Menu, MenuItem, Typography } from "@mui/material";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { AuthContext } from "../context/auth";
import { Link } from "react-router-dom";
import { Link as MUILink } from "@mui/material";
import { useHistory } from "react-router-dom";
import { deleteJwtCookie } from "./navigation-item";

export default function UserProfileDropdown() {
  const { user, setUser, userImageUrl, setJwt } = useContext(AuthContext);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const history = useHistory();
  const isOpen = Boolean(anchorEl);

  const handleClick = (event: any) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const logout = () => {
    deleteJwtCookie();
    setUser(undefined);
    setJwt("");
    history.push("/");
  };

  const fullName =
    `${user?.user_profile.first_name ?? ""} ${user?.user_profile.last_name ?? ""}`.trim();
  const initials = [user?.user_profile.first_name, user?.user_profile.last_name]
    .filter((n): n is string => Boolean(n))
    .map((n) => n[0])
    .join("")
    .toUpperCase();

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          px: "10px",
          py: "6px",
          mr: "4px",
          borderRadius: "8px",
          cursor: "pointer",
          transition: "background-color 0.15s ease",
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.06)",
          },
        }}
      >
        <Avatar
          alt={fullName}
          src={userImageUrl}
          sx={{
            width: 28,
            height: 28,
            fontSize: "11px",
            fontWeight: 600,
            backgroundColor: "rgba(99,102,241,0.35)",
            border: "1.5px solid rgba(99,102,241,0.45)",
            color: "#a5b4fc",
          }}
        >
          {initials || "?"}
        </Avatar>
        <Typography
          sx={{
            fontSize: "13px",
            fontWeight: 500,
            color: "rgba(255,255,255,0.8)",
            letterSpacing: "0.01em",
            maxWidth: "120px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {fullName || "Account"}
        </Typography>
        <KeyboardArrowDownIcon
          sx={{
            fontSize: "15px",
            color: "rgba(255,255,255,0.35)",
            transition: "transform 0.15s ease",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            flexShrink: 0,
          }}
        />
      </Box>

      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={isOpen}
        onClose={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        PaperProps={{
          sx: {
            mt: "6px",
            background: "#131720",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: "10px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.45)",
            minWidth: "168px",
            "& .MuiList-root": { py: "4px" },
          },
        }}
      >
        <MenuItem
          onClick={handleClose}
          sx={{
            py: "8px",
            px: "12px",
            mx: "4px",
            borderRadius: "6px",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.05)" },
          }}
        >
          <Link
            to="/my-account"
            style={{
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <AccountCircleRoundedIcon
              sx={{ fontSize: "16px", color: "#818cf8" }}
            />
            <Typography
              sx={{
                fontSize: "13px",
                color: "rgba(255,255,255,0.75)",
                fontWeight: 500,
              }}
            >
              My Account
            </Typography>
          </Link>
        </MenuItem>

        <Divider sx={{ borderColor: "rgba(255,255,255,0.07)", my: "4px" }} />

        <MenuItem
          onClick={handleClose}
          sx={{
            py: "8px",
            px: "12px",
            mx: "4px",
            borderRadius: "6px",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.05)" },
          }}
        >
          <MUILink
            underline="none"
            onClick={logout}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
            }}
          >
            <ExitToAppIcon sx={{ fontSize: "16px", color: "rgba(239,68,68,0.7)" }} />
            <Typography
              sx={{
                fontSize: "13px",
                color: "rgba(255,255,255,0.75)",
                fontWeight: 500,
              }}
            >
              Logout
            </Typography>
          </MUILink>
        </MenuItem>
      </Menu>
    </>
  );
}
